(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-compare-slider"] && !Shopify.designMode) return;
  try {
    
  class WaveCompare extends HTMLElement {
    connectedCallback() {
      const compareEl = this.querySelector('[data-compare]');
      const beforeWrap = this.querySelector('[data-before-wrap]');
      const handle = this.querySelector('[data-handle]');
      const range = this.querySelector('[data-range]');
      if (!compareEl || !beforeWrap || !handle || !range) return;

      const setCompare = (pos) => {
        pos = Math.max(0, Math.min(100, pos));
        beforeWrap.style.clipPath = `inset(0 ${100 - pos}% 0 0)`;
        handle.style.left = pos + '%';
      };
      setCompare(50);

      range.addEventListener('input', (e) => setCompare(Number(e.target.value)));

      compareEl.addEventListener('pointerdown', (e) => {
        const rect = compareEl.getBoundingClientRect();
        const move = (ev) => {
          const x = ev.clientX ?? rect.left;
          const pct = ((x - rect.left) / rect.width) * 100;
          setCompare(pct);
          range.value = pct;
        };
        move(e);
        const up = () => {
          window.removeEventListener('pointermove', move);
          window.removeEventListener('pointerup', up);
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
      });
    }
  }
  customElements.define('wave-compare', WaveCompare);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class WaveCarousel extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-track]');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (!track) return;
      const scrollByCard = (dir) => {
        const card = track.querySelector('[data-card]');
        const gap = 22;
        const amount = card ? (card.getBoundingClientRect().width + gap) * dir : 260 * dir;
        track.scrollBy({ left: amount, behavior: 'smooth' });
      };
      prev && prev.addEventListener('click', () => scrollByCard(-1));
      next && next.addEventListener('click', () => scrollByCard(1));
    }
  }
  customElements.define('wave-carousel', WaveCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-service-contact"] && !Shopify.designMode) return;
  try {
    
  class WaveFadeCarousel extends HTMLElement {
    connectedCallback() {
      const slides = Array.from(this.querySelectorAll('[data-fade-slide]'));
      if (slides.length < 2) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;
      let index = 0;
      setInterval(() => {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, 5000);
    }
  }
  customElements.define('wave-fade-carousel', WaveFadeCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
  class WaveTestiCarousel extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-track]');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const dotsWrap = this.querySelector('[data-dots]');
      if (!track) return;

      const cards = Array.from(track.children);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let index = 0;
      let timer = null;

      if (dotsWrap) {
        cards.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'wave-testi__dot';
          dot.setAttribute('aria-label', 'Ir a reseña ' + (i + 1));
          dot.addEventListener('click', () => { goTo(i); restart(); });
          dotsWrap.appendChild(dot);
        });
      }
      const dots = dotsWrap ? Array.from(dotsWrap.children) : [];
      const updateDots = () => dots.forEach((d, i) => d.classList.toggle('is-active', i === index));

      const goTo = (i) => {
        index = (i + cards.length) % cards.length;
        const target = cards[index];
        const left = target.offsetLeft - track.offsetLeft;
        track.scrollTo({ left: left, behavior: 'smooth' });
        updateDots();
      };
      const step = (dir) => goTo(index + dir);

      next && next.addEventListener('click', () => { step(1); restart(); });
      prev && prev.addEventListener('click', () => { step(-1); restart(); });

      const start = () => { if (!reduceMotion) timer = setInterval(() => step(1), 6000); };
      const stop = () => { clearInterval(timer); };
      const restart = () => { stop(); start(); };

      this.addEventListener('mouseenter', stop);
      this.addEventListener('mouseleave', start);
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', restart, { passive: true });

      let scrollTimeout;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const cardWidth = cards[0].getBoundingClientRect().width + 24;
          index = Math.round(track.scrollLeft / cardWidth);
          updateDots();
        }, 120);
      });

      updateDots();
      start();
    }
  }
  customElements.define('wave-testi-carousel', WaveTestiCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
